// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"TableContainer_tableContainer__3MCnA","sidePadding":"TableContainer_sidePadding__2tVkl"};